import {TextInput, LoadButton, NavigateSmart, LinkSmart} from './Common';
import {useContext, useState} from 'react';
import './Login.css';
import {postWithCsrf, loginFunc, checkEmail} from './util';
import { LocaleContext, LoginContext, ScrollContext, StateContext } from './App';
import { Link} from 'react-router-dom';
import { LoadState, TwoFactorAuthType } from './enums';
import { maxPasswordLength, maxUsernameLength, skipTwoFactorAuth } from './globals';
import { useNavigateSmart } from './hooks';

export function Login(props) {
    const [email, setEMail] = useState("");
    const [password, setPassword] = useState("");
    const [errorText, setErrorText] = useState(null);
    const [loadState, setLoadState] = useState(LoadState.NONE);

    const login = useContext(LoginContext);
    const state = useContext(StateContext);
    const locale = useContext(LocaleContext);
    const scroll = useContext(ScrollContext);

    const navigate = useNavigateSmart();


    // FUNCTIONS:

    function checkInputForButton() {
        if(!email || !password) {
            return false;
        }

        if(email.length > maxUsernameLength) {
            return false;
        }

        if(password.length > maxPasswordLength) {
            return false;
        }

        if(email === "" || password === ""){
            return false;
        }

        return true
    }

    function handleSubmit(e) {
        e.preventDefault();

        if(checkInputForButton()){
            if(skipTwoFactorAuth) {
                myLogin();
            }
            else {
                login2fa();
            }
        }
    }

    function login2fa() {
        try {
            let url = "/user/is_two_factor_auth_enabled";

            if(props.management) {
                url = "/user/management/is_two_factor_auth_enabled";
            }

            postWithCsrf(
                url,
                JSON.stringify({email: email, password: password}),
                state
            ).then((response) => {
                if(response.ok) {
                    return response.json();
                }

                throw new Error("Response code: " + response.status);
            }).then((json) => {
                if(json.two_factor_auth_enabled && !json.known_device) {
                    setLoadState(LoadState.LOAD_SUCCESS);
                    login.setUsername(email);
                    login.setPassword(password);

                    login.setTwoFactorAuthType(json.two_factor_auth_type);

                    if(json.two_factor_auth_type === TwoFactorAuthType.MOBILE) {
                        login.setNextSmsCountS(Math.round(json.next_sms_count_s));
                    }

                    navigate("/two_factor_auth");
                }
                else {
                    myLogin();
                }
            }).catch((error) => {
                setLoadState(LoadState.LOAD_ERROR);

                console.log("Login ERROR: " + error);

                setErrorText(
                    <div className="text_error">
                        {locale.msgs.LOGIN_FAILED}
                    </div>
                )
            });

            // Calling setLoadState() after postWithCsrf() as it could throw an exception
            setLoadState(LoadState.LOADING);
            setErrorText("");
        }
        catch(e) {
            console.log(e);
        }
    }

    function myLogin() {
        try {
            loginFunc(email, password, "", state, login, props.management).then((json) => {
                setLoadState(LoadState.LOAD_SUCCESS);

                props.onLogin(json);
            }).catch((error) => {
                setLoadState(LoadState.LOAD_ERROR);

                console.log("Login ERROR: " + error);
            
                setErrorText(
                    <div className="text_error">
                        {locale.msgs.LOGIN_FAILED}
                    </div>
                );
            });

            // Calling setLoadState() after loginFunc() as it could throw an exception
            setLoadState(LoadState.LOADING);
		}
		catch(e) {
			console.log(e);
		}
    }


    // RENDER:

    let inputValid = checkInputForButton();

    return (
        <div className="bottom_padding" id="login">
            { login.loggedIn ?
                <NavigateSmart to="/dashboard" />
            :
                null
            }

            <form onSubmit={handleSubmit}>
                <div id="email_box">
                    { props.management ?
                        <TextInput text={locale.msgs.USERNAME} name="email" type="text" autocomplete="user" value={email} onChange={(value) => setEMail(value)}
                                maxLength={maxUsernameLength} />
                    :
                        <TextInput text={locale.msgs.EMAIL} name="email" type="email" autocomplete="email" value={email}
                                onChange={(value) => setEMail(value)}
                                checker={(v) => checkEmail(v)}
                                errorText={locale.msgs.ENTER_VALID_EMAIL_ADDRESS}
                                maxLength={maxUsernameLength} />
                    }
                </div>

                <div id="password_box">
                    <TextInput text={locale.msgs.PASSWORD} name="password" type="password" autocomplete="current-password" value={password}
                            onChange={(value) => setPassword(value)}
                            maxLength={maxPasswordLength} />

                    { props.hideForgotPwd ? 
                        null
                    :
                        <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} to="/forgot_password" id="forgot_password">Passwort vergessen?</LinkSmart>
                    }
                </div>

                <div id="login_box">
                    <LoadButton white={false} text={locale.msgs.LOGIN}
                            clickable={inputValid}
                            saving={loadState === LoadState.LOADING}
                            onClick={(e) => {}}
                            notSaved={false}
                            saved={false}
                            sucText={""} errText={""}
                            submit={true}
                    />
                </div>

                { props.hideRegister ?
                    null
                :
                    <div id="register_box">
                        <div id="no_account">{locale.msgs.NO_ACCOUNT_YET}</div>
                        <LinkSmart onClick={() => scroll.scrollToPlain(0, 0)} to="/register" id="register_btn">{locale.msgs.REGISTER}</LinkSmart>
                    </div>
                }
            </form>

            {errorText}
        </div>
    );
}
